<template>
  <div>
    <!-- Adicionar novo -->
    <cliente-list-add-new
      :is-add-new-cliente-sidebar-active.sync="isAddNewClienteSidebarActive"
      :situacao-options="situacaoOptions"
      :tipo-pessoa-options="tipoPessoaOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <!-- <cliente-list-filters
      :situacao-filter.sync="situacaoFilter"
      :situacao-options="situacaoOptions"
    /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="9"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Procurar..."
                debounce="600"
              />
              <!-- <b-button
                variant="primary"
                @click="isAddNewClienteSidebarActive = true"
              >
                <span class="text-nowrap">Adicionar Devedor</span>
              </b-button> -->
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refClienteListTable"
        class="position-relative"
        responsive
        striped
        hover
        :items="fetchClientes"
        :fields="tableColumns"  
        primary-key="id"
        show-empty
        empty-text="Nenhum registro encontrado"
      >
        <!-- Column: User -->
        <template #cell(nome)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :text="avatarText(data.item.nome)"
                variant="light-danger"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap" 
            >
              {{ data.item.nome }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: Status -->
        <template #cell(situacao)="data">
          <b-badge
            pill
            :variant="`light-${resolveClienteStatusVariant(data.item.situacao)}`"
            class="text-capitalize"
          >
            {{ data.item.situacao }}
          </b-badge>
        </template>

        <!-- Column: Credor -->
        <template #cell(credor)="data">
          <span class="font-weight-bolder">{{ data.item.credor }}</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            size="sm"
            variant="outline-secondary"
            target="_blank"
            :to="{ name: 'edit-cliente-credor', params: { id: data.item.id } }"
          >
            Editar
            <feather-icon
              icon="EditIcon"
              class="ml-50"
            />
          </b-button>
        </template>

      </b-table>

      <!-- METADATA -->
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo de {{ dataMeta.from }} até {{ dataMeta.to }} de {{ dataMeta.total }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="dataMeta.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, computed} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import ClienteListFilters from './ClienteListFilters.vue'
import ClienteListAddNew from './ClienteListAddNew.vue'
import ClienteEdit from './ClienteEdit.vue'
import useClienteList from './useClienteList'
import clienteStoreModule from '../clienteStoreModule'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'

export default {
  components: {
    // ClienteListFilters,
    ClienteListAddNew,
    ClienteEdit,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup() {
    const CLIENTE_APP_STORE_MODULE_NAME = 'app-cliente'

    // Register module
    if (!store.hasModule(CLIENTE_APP_STORE_MODULE_NAME)) store.registerModule(CLIENTE_APP_STORE_MODULE_NAME, clienteStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CLIENTE_APP_STORE_MODULE_NAME)) store.unregisterModule(CLIENTE_APP_STORE_MODULE_NAME)
    })

    const isAddNewClienteSidebarActive = ref(false)

    const situacaoOptions = [
      { label: 'Ativo', value: 'ATIVO' },
      { label: 'Inativo', value: 'INATIVO' }
    ]

    const tipoPessoaOptions = [
      { label: 'Pessoa Física', value: 'PF' },
      { label: 'Pessoa Jurídica', value: 'PJ' }
    ]

    const {
      fetchClientes,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refClienteListTable,
      refetchData,

      // UI
      resolveClienteStatusVariant,

      // Extra Filters
      situacaoFilter,
      tipoPessoaFilter
    } = useClienteList()
    

    return {

      // Sidebar
      isAddNewClienteSidebarActive,

      fetchClientes,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refClienteListTable,
      refetchData,

      // Filter
      avatarText,    

      // UI
      resolveClienteStatusVariant,

      situacaoOptions,
      tipoPessoaOptions,

      // Extra Filters
      situacaoFilter,
      tipoPessoaFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
